import CodingZoom from "./CodingZoom";
import CodingSplit from "./CodingSplit";
import constants from "../../../constants";
import Profile from "../Home/LandingPage/Profile";
import React, { useContext, useEffect } from "react";
import AlertContext from "../../../context/AlertContext";
import Notify from "../../Notification-Loading/Notify/Notify";
import Loading from "../../Notification-Loading/Loading/Loading";
import CodingPageHooks from "../../../Hooks/CodingPage/CodingPageHooks";
import AudioCompare from "../../CommonComponents/AudioCompare/AudioCompare";
import ConfirmNotify from "../../Notification-Loading/ConfirmNotify/ConfirmNotify";
import CodingPageDetailsHooks from "../../../Hooks/CodingPage/CodingPageDetailsHooks";
import CodingHeaderLearnerSideHooks from "../../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";

export default function CodingPage() {
  const Alert = useContext(AlertContext);

  const CodingPgHooks = CodingPageHooks();
  const CodingHeaderLearnerSideHks = CodingHeaderLearnerSideHooks();

  CodingPageDetailsHooks();

  !Alert.isAdmin &&
    (window.onpopstate = () => {
      window.history.pushState({}, "", Alert.navigate("/home"));
    });

  useEffect(() => {
    if (Alert.isTakeTest) {
      CodingPgHooks.setShowingDelay(true);
      CodingPgHooks.ProfileReturn();
    }
  }, [Alert.isTakeTest]);

  useEffect(() => {
    const preventActions = (event) => {
      if (!Alert.isAdmin) {
        if (event.dataTransfer) {
          try {
            event.dataTransfer.dropEffect = "none";
          } catch (err) { }
        }

        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener("keydown", (event) => {
      if (!Alert.isAdmin) CodingPgHooks.preventCopyAndCut(event);
    });

    document.addEventListener("drop", preventActions);
    document.addEventListener("paste", preventActions);
    document.addEventListener("dragend", preventActions);
    document.addEventListener("dragover", preventActions);
    document.addEventListener("dragstart", preventActions);
    document.removeEventListener("keyup", (e) =>
      CodingPgHooks.preventCopyAndCut(e)
    );

    document.addEventListener("keydown", (e) => {
      CodingPgHooks.preventCopyAndCut(e);
    });

    return () => {
      document.removeEventListener("drop", preventActions);
      document.removeEventListener("paste", preventActions);
      document.removeEventListener("dragend", preventActions);
      document.removeEventListener("dragover", preventActions);
      document.removeEventListener("dragstart", preventActions);

      document.removeEventListener("keyup", (e) =>
        CodingPgHooks.preventCopyAndCut(e)
      );

      document.removeEventListener("keydown", (e) => {
        CodingPgHooks.preventCopyAndCut(e);
      });
    };
  }, []);

  useEffect(() => {
    if (
      !Alert.isAdmin &&
      Alert.testData.testmode === constants.MODE.TEST_MODE &&
      Alert.status !== constants.QUESTION_STATUS.SUBMITTED &&
      Alert.status !== constants.QUESTION_STATUS.TO_BE_EVALUATED &&
      Alert.resultCode !== constants.RESULT_STATUS.NETWORK_ISSUE
    ) {

    /* OLD blur,focus handling */
      // window.addEventListener("blur", CodingHeaderLearnerSideHks.onBlur);
      // window.addEventListener("focus", CodingHeaderLearnerSideHks.onFocus);

      // return () => {
      //   window.removeEventListener("blur", CodingHeaderLearnerSideHks.onBlur);
      //   window.removeEventListener("focus", CodingHeaderLearnerSideHks.onFocus);
      // };
    /*-- OLD blur,focus handling --*/

    /* NEW blur,focus handling */

    // ── 1. Track whether focus is currently inside a TinyMCE iframe ──
    let isFocusInIframe = false;
    let blurCallLock = false; // Prevent duplicate onBlur calls

    const triggerBlur = () => {
      if (blurCallLock) return; // Already handled
      blurCallLock = true;
      CodingHeaderLearnerSideHks.onBlur();
    };

    const triggerFocus = () => {
      blurCallLock = false; // Reset lock on focus
      isFocusInIframe = false;
      CodingHeaderLearnerSideHks.onFocus();
    };

    const handleBlur = () => {
      requestAnimationFrame(() => {
        const focusedElement = document.activeElement;

        if (focusedElement && focusedElement.tagName === "IFRAME") {
          isFocusInIframe = true;
          return;
        }

        isFocusInIframe = false;
        triggerBlur(); // Use guarded trigger
      });
    };

    const handleFocus = () => {
      triggerFocus(); // Use guarded trigger
    };

    const attachIframeBlurListener = () => {
      const iframes = document.querySelectorAll("iframe");

      iframes.forEach((iframe) => {
        if (iframe._blurHandler) return; // Already attached, skip
        try {
          const iframeWindow = iframe.contentWindow;
          if (!iframeWindow) return;

          const iframeBlurHandler = () => {
            requestAnimationFrame(() => {
              const mainFocused = document.hasFocus();
              const iframeFocused =
                iframeWindow.document?.hasFocus?.() || false;

              if (!mainFocused && !iframeFocused) {
                triggerBlur(); // Use guarded trigger
              }
            });
          };

          const iframeFocusHandler = () => {
            isFocusInIframe = true;
            triggerFocus(); // Use guarded trigger
          };

          iframeWindow.addEventListener("blur", iframeBlurHandler);
          iframeWindow.addEventListener("focus", iframeFocusHandler);

          iframe._blurHandler = iframeBlurHandler;
          iframe._focusHandler = iframeFocusHandler;
        } catch (e) {
          console.warn("Could not attach to iframe:", e);
        }
      });
    };

    const detachIframeBlurListener = () => {
      const iframes = document.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        try {
          const iframeWindow = iframe.contentWindow;
          if (!iframeWindow) return;

          if (iframe._blurHandler)
            iframeWindow.removeEventListener("blur", iframe._blurHandler);
          if (iframe._focusHandler)
            iframeWindow.removeEventListener("focus", iframe._focusHandler);

          // Clean up stored handlers
          delete iframe._blurHandler;
          delete iframe._focusHandler;
        } catch (e) {}
      });
    };

    attachIframeBlurListener();

    const iframeObserver = new MutationObserver(() => {
      attachIframeBlurListener();
    });

    iframeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
      detachIframeBlurListener();
      iframeObserver.disconnect();
    };

    }
  }, [Alert.status, CodingHeaderLearnerSideHks.onBlur, Alert.resultCode]);

  useEffect(() => {
    if (
      !Alert.isAdmin &&
      Alert.testData.testmode === constants.MODE.TEST_MODE &&
      Alert.status !== constants.QUESTION_STATUS.SUBMITTED &&
      Alert.status !== constants.QUESTION_STATUS.TO_BE_EVALUATED &&
      Alert.resultCode !== constants.RESULT_STATUS.NETWORK_ISSUE
    ) {
      if (!document.fullscreenElement) {
        CodingHeaderLearnerSideHks.checkFullScreen();
      }
    }
  }, [
    Alert.isAdmin,
    Alert.resultCode,
    Alert.codeDetails.status,
    document.fullscreenElement,
  ]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (
        e.key === "F5" ||
        (e.ctrlKey && e.key === "r") ||
        (e.ctrlKey && e.shiftKey && e.key === "R")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    Object.keys(Alert.codeDetails).length !== 0 && (
      <div
        onContextMenu={CodingPgHooks.handleContextMenu}
        className={
          !Alert.isFullScreen
            ? "codingPageMainContainer"
            : "codingPageMainContainerFullScreen"
        }
      >
        {/* TODO: Zoom Integration */}
        {!Alert.isAdmin && Alert.isTakeTest && CodingPgHooks.showingDelay && (
          <CodingZoom />
        )}
        {/* TODO: Zoom Integration */}
        <CodingSplit />
        {Alert.isTakeTest && CodingPgHooks.showingDelay && (
          <Profile
            type="verfypic"
            setMsg={Alert.setMsg}
            setShow={Alert.setShow}
            setTitle={Alert.setTitle}
            details={Alert.codeDetails}
            isTakeTest={Alert.isTakeTest}
            camAvailable={Alert.camAvailable}
            questionid={Alert.codeDetails.qnid}
            setCamAvailable={Alert.setCamAvailable}
            isNextQuestion={CodingPgHooks.isNextQuestion}
            setCameraPopup={CodingPgHooks.setCameraPopup}
            setCameraWarningMsg={Alert.setCameraWarningMsg}
            libtypeid={constants.libTypeIds.CODING_CHALLENGE}
            setIsNextQuestion={CodingPgHooks.setIsNextQuestion}
          />
        )}
        <Notify
          svg={Alert.svg}
          show={Alert.show}
          title={Alert.title}
          message={Alert.msg}
          btnText={Alert.btnText}
          resultCode={Alert.resultCode}
          onHide={
            Alert.isUnAuth && Alert.isAdmin
              ? Alert.handleUnAuthAlert
              : Alert.resultCode === constants.RESULT_STATUS.NETWORK_ISSUE &&
                !Alert.isAdmin
                ? CodingHeaderLearnerSideHks.handleSaveTest
                : Alert.isShowTimeAlert
                  ? CodingHeaderLearnerSideHks.handleNavigateToHome
                  : Alert.handleClose
          }
        />
        {Alert.isLoaded && <Loading />}
        <ConfirmNotify
          svg={Alert.svg}
          title={Alert.title}
          message={Alert.msg}
          btnText={Alert.btnText}
          btnText2={Alert.btnText2}
          resultCode={Alert.resultCode}
          show={Alert.showConfirmNotify}
          onHide2={
            Alert.resultCode === constants.RESULT_STATUS.INCORRECT_ANSWER
              ? CodingHeaderLearnerSideHks.handleQuitTest
              : Alert.resultCode === constants.RESULT_STATUS.TIMEOUT
                ? CodingHeaderLearnerSideHks.handleTimeOut
                : CodingHeaderLearnerSideHks.handleNavigateToHome
          }
          onHide={
            Alert.resultCode === constants.RESULT_STATUS.SUCCESS
              ? CodingPgHooks.handleAssignNextQnToLearner
              : () => {
                Alert.setMsg("");
                Alert.setSvg("");
                Alert.setBtnText("");
                Alert.setBtnText2("");
                Alert.setResultCode("");
                Alert.setShowConfirmNotify(false);
              }
          }
        />

        {/* {Alert.isTakeTest &&
          !Alert.isAdmin &&
          Alert.testData.testmode === constants.MODE.TEST_MODE &&
          Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM && (
            <div>
              <AudioCompare />
            </div>
          )} */}
      </div>
    )
  );
}
